import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CustomTermsOfServiceConfigurationInput extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })),
  }

  static defaultProps = {
    value: [],
  }

  constructor(props) {
    super(props);

    const termsList = this.props.value || [];
    if (termsList.length === 0) {
      termsList.push({ name: '', url: '' });
    }
    this.state = { termsList };
  }

  addMore = (e) => {
    e.preventDefault();
    const termsList = this.state.termsList;
    termsList.push({ name: '', url: '' });
    this.setState({ termsList });
  }

  removeTerms = (index, e) => {
    e.preventDefault();
    const termsList = this.state.termsList;
    termsList.splice(index, 1);
    this.setState({ termsList });
  }

  editName = (index, e) => {
    const termsList = this.state.termsList;
    termsList[index].name = e.target.value;
    this.setState({ termsList });
  }

  editUrl = (index, e) => {
    const termsList = this.state.termsList;
    termsList[index].url = e.target.value;
    this.setState({ termsList });
  }

  cleanTermsList = () => (
    this.state.termsList.filter((t) => (
      t.name.trim().length > 0 && t.url.trim().length > 0
    )).map((t) => (
      this.autoPrependSchemaToUrl(t)
    ))
  )

  autoPrependSchemaToUrl = (terms) => {
    const newTerms = Object.assign({}, terms);

    if (!terms.url.startsWith('http://') && !terms.url.startsWith('https://')) {
      newTerms.url = `http://${terms.url}`;
    }

    return newTerms;
  }

  renderAddMoreButton = () => (
    <button className="Button Button--tiny" onClick={this.addMore}>
      <i className="Icon Icon-plus-square u-mr-1" />
      Add more
    </button>
  )

  renderTerms = (tos, i) => (
    <div className="u-flex u--mx-2" key={`terms-${i}`}>
      <div className="u-w-1/3 u-px-2 h-12">
        <label className="string" htmlFor={`terms-name-${i}`}>Document Name</label>
        <input
          id={`terms-name-${i}`}
          type="text"
          value={tos.name}
          placeholder="Terms & Conditions"
          onChange={this.editName.bind(null, i)}
        />
      </div>
      <div className="u-flex-1 u-px-2 h-12">
        <label className="string" htmlFor={`terms-url-${i}`}>URL</label>
        <input
          id={`terms-url-${i}`}
          type="text"
          value={tos.url}
          placeholder="http://example.com/terms-of-service"
          onChange={this.editUrl.bind(null, i)}
        />
      </div>
      <div className="u-w-1/8 u-px-2 h-12">
        <a onClick={this.removeTerms.bind(null, i)}>
          <i className="Icon Icon-delete u-mt-10 u-cursor-pointer" />
        </a>
      </div>
    </div>
  );

  render() {
    return (
      <div className="u-mt-6">
        { this.state.termsList.map((tos, i) => this.renderTerms(tos, i)) }

        { this.state.termsList.length < 10 && this.renderAddMoreButton() }

        <input name={this.props.name} type="hidden" value={JSON.stringify(this.cleanTermsList())} />
      </div>
    );
  }
}
